module.exports = wtr_shared_18_19_0;